export default "__VITE_ASSET__B19Youz5__"